// LeanCustoms Declaration Statuses
// Based on LeanCustoms API documentation for DMS declaration statuses

export const LEANCUSTOMS_DECLARATION_STATUSES = [
  'not_submitted',
  'submitted',
  'rejected',
  'registered',
  'presentation_notification_submitted',
  'presentation_notification_rejected',
  'accepted',
  'supplementary_declaration_submitted',
  'supplementary_declaration_received',
  'supplementary_declaration_rejected',
  'supplementary_declaration_expired',
  'amendment_submitted',
  'amendment_received',
  'amendment_rejected',
  'amendment_accepted',
  'provisional_release',
  'information_requested',
  'provide_information',
  'resolution_submitted',
  'resolution_rejected',
  'resolution_received',
  'definitive_release',
  'provide_exit_evidence',
  'exit_evidence_submitted',
] as const;

export type LeanCustomsDeclarationStatus = typeof LEANCUSTOMS_DECLARATION_STATUSES[number];

// Status ordering for UI display (workflow order)
export const DECLARATION_STATUS_ORDER: LeanCustomsDeclarationStatus[] = [
  'not_submitted',
  'submitted',
  'registered',
  'presentation_notification_submitted',
  'accepted',
  'provisional_release',
  'definitive_release',
  'information_requested',
  'provide_information',
  'resolution_submitted',
  'resolution_received',
  'provide_exit_evidence',
  'exit_evidence_submitted',
  'supplementary_declaration_submitted',
  'supplementary_declaration_received',
  'amendment_submitted',
  'amendment_received',
  'amendment_accepted',
  'rejected',
  'presentation_notification_rejected',
  'supplementary_declaration_rejected',
  'supplementary_declaration_expired',
  'amendment_rejected',
  'resolution_rejected',
];

// Status colors for UI display
export const DECLARATION_STATUS_COLORS: Record<string, string> = {
  // Success/Completed states
  accepted: 'green',
  definitive_release: 'green',
  provisional_release: 'green',
  registered: 'green',
  resolution_received: 'green',
  amendment_accepted: 'green',
  amendment_received: 'green',
  supplementary_declaration_received: 'green',
  exit_evidence_submitted: 'green',
  
  // In progress states
  submitted: 'blue',
  presentation_notification_submitted: 'blue',
  information_requested: 'blue',
  provide_information: 'blue',
  resolution_submitted: 'blue',
  provide_exit_evidence: 'blue',
  supplementary_declaration_submitted: 'blue',
  amendment_submitted: 'blue',
  
  // Pending/Initial states
  not_submitted: 'default',
  
  // Error/Rejected states
  rejected: 'red',
  presentation_notification_rejected: 'red',
  supplementary_declaration_rejected: 'red',
  supplementary_declaration_expired: 'red',
  amendment_rejected: 'red',
  resolution_rejected: 'red',
};

// Human-readable status labels
export const DECLARATION_STATUS_LABELS: Record<string, string> = {
  not_submitted: 'Not Submitted',
  submitted: 'Submitted',
  rejected: 'Rejected',
  registered: 'Registered',
  presentation_notification_submitted: 'Presentation Notification Submitted',
  presentation_notification_rejected: 'Presentation Notification Rejected',
  accepted: 'Accepted',
  supplementary_declaration_submitted: 'Supplementary Declaration Submitted',
  supplementary_declaration_received: 'Supplementary Declaration Received',
  supplementary_declaration_rejected: 'Supplementary Declaration Rejected',
  supplementary_declaration_expired: 'Supplementary Declaration Expired',
  amendment_submitted: 'Amendment Submitted',
  amendment_received: 'Amendment Received',
  amendment_rejected: 'Amendment Rejected',
  amendment_accepted: 'Amendment Accepted',
  provisional_release: 'Provisional Release',
  information_requested: 'Information Requested',
  provide_information: 'Provide Information',
  resolution_submitted: 'Resolution Submitted',
  resolution_rejected: 'Resolution Rejected',
  resolution_received: 'Resolution Received',
  definitive_release: 'Definitive Release',
  provide_exit_evidence: 'Provide Exit Evidence',
  exit_evidence_submitted: 'Exit Evidence Submitted',
};

